import { FlexBox, Colors, BrgButton } from "@brg/ui";
import styled from "styled-components";
import { RectangularButtonFilled } from "../../components/buttons";
import {LayoutConst} from "../../../core";

export const ArtzLegalsWrapper = styled(FlexBox)<{height: number}>`
    width: 860px;
    height: 522px;
    padding: 56px 80px 40px 80px;
    flex-flow: column;
    position: relative;
    background-color: #FEFEFE;
    justify-content: center;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;

    @media (max-width: ${LayoutConst.screen.m}px) {
      width: calc(100% - 74px);
      height: ${({height}) => height * 0.835}px;
      margin: 0 37px;
      padding: 48px 28px 24px 28px;
    }
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      width: calc(100% - 24px);
      height: ${({height}) => height * 0.745}px;
      margin: ${({height}) => height * 0.12}px 12px 0;
      padding: 16px 12px;
    }
`;

export const LegalsCloseWrapper = styled.div`
    position: absolute;
    top: 32px;
    right: 32px;
    cursor: pointer;

  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 29px;
    right: 17px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
    
    svg {
      width: 18px;
      height: 18px;
      path {
        fill: #FEFEFE;
      }
    }
  }
`;

export const LegalsTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #151514;
    padding-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
    padding-bottom: 12px;
  }
`;

export const LegalsShadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  height: 40px;
`

export const LegalsContentShadowWrapper = styled.div`
  position: relative;

  @media (max-width: ${LayoutConst.screen.m}px) {
    overflow-y: auto;
  }
`

export const LegalsContent = styled.div`
    // padding-top: 24px;
    max-height: 317px;
    overflow-y: auto;
    color: #70706F;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    padding-bottom: 40px;

    a {
        color: #70706F;
    }

    a:hover {
        color: #151514;
    }

    &::-webkit-scrollbar {
        height: 1px;
        width: 2px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: none;
    height: 100%;
    padding-right: 16px;
    font-size: 17px;
    line-height: 22px;
    &::-webkit-scrollbar {
      width: 3px;
    }

    a {
      border-bottom: 1px #70706F solid;
    }

    a:hover {
      border-bottom: 1px #70706F solid;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: normal;

    a {
      border-bottom: none;
    }

    a:hover {
      border-bottom: none;
    }
  }
`;

export const LegalsBtn = styled.div`
    padding-top: 24px;
    display: flex;
    justify-content: center;

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding-top: 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 12px;
  }
`;

export const ApproveBtn = styled(BrgButton)`
    width: 186px;
    color: #FFFFFF;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 131px;
  }
`;

import { FlexBox, Colors, BrgButton } from "@brg/ui";
import styled from "styled-components";
import { RectangularButtonFilled } from "../../components/buttons";
import {LayoutConst} from "../../../core";

export const ArtzLegalsWrapper = styled(FlexBox)<{height: number}>`
    width: 860px;
    height: 522px;
    padding: 56px 80px 40px 80px;
    flex-flow: column;
    position: relative;
    background-color: #FEFEFE;
    justify-content: center;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;

    @media (max-width: ${LayoutConst.screen.m}px) {
      width: calc(100% - 74px);
      height: ${({height}) => height * 0.835}px;
      margin: 0 37px;
      padding: 48px 28px 24px 28px;
    }
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      width: calc(100% - 24px);
      height: ${({height}) => height * 0.745}px;
      margin: ${({height}) => height * 0.12}px 12px 0;
      padding: 16px 12px;
    }
`;

export const LegalsCloseWrapper = styled.div`
    position: absolute;
    top: 32px;
    right: 32px;
    cursor: pointer;

  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 29px;
    right: 17px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
    
    svg {
      width: 18px;
      height: 18px;
      path {
        fill: #FEFEFE;
      }
    }
  }
`;

export const LegalsTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #151514;
    padding-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
    padding-bottom: 12px;
  }
`;

export const LegalsShadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  height: 40px;
`

export const LegalsContentShadowWrapper = styled.div`
  position: relative;

  @media (max-width: ${LayoutConst.screen.m}px) {
    overflow-y: auto;
  }
`

export const LegalsContent = styled.div`
    // padding-top: 24px;
    max-height: 317px;
    overflow-y: auto;
    color: #70706F;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    padding-bottom: 40px;

    a {
        color: #70706F;
    }

    a:hover {
        color: #151514;
    }

    &::-webkit-scrollbar {
        height: 1px;
        width: 2px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: none;
    height: 100%;
    padding-right: 16px;
    font-size: 17px;
    line-height: 22px;
    &::-webkit-scrollbar {
      width: 3px;
    }

    a {
      border-bottom: 1px #70706F solid;
    }

    a:hover {
      border-bottom: 1px #70706F solid;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: normal;

    a {
      border-bottom: none;
    }

    a:hover {
      border-bottom: none;
    }
  }
`;

export const LegalsBtn = styled.div`
    padding-top: 24px;
    display: flex;
    justify-content: center;

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding-top: 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 12px;
  }
`;

export const ApproveBtn = styled(BrgButton)`
    width: 186px;
    color: #FFFFFF;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 131px;
  }
`;

